import { Divider, Flex, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../Components/Button"
import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"
import Images from "../../../../Images"

import "./styles.less"

const { Title, Text } = Typography
const PremiumCard = ({ data, onClick, style, theme }) => {
  const { t } = useTranslation()
  const btnText = data.is_active ? "Subscribed" : "Subscribe"
  return (
    <Flex vertical gap={16} className="premium-card" style={{ ...style }}>
      <Flex align="center">
        <Title
          level={4}
          style={{
            lineHeight: "22px",
            paddingRight: 6,
            margin: 0,
            maxWidth: 194
          }}
        >
          {data?.["connect_page_description"]}
        </Title>
        {Images[`integration_${data.service_name}`] ? (
          <img
            src={
              Images[
                `integration_${data.service_name}${data.service_name === "premium_support" && theme === "dark" ? "_dark" : ""}`
              ]
            }
            alt={data.service_name}
          />
        ) : null}
      </Flex>

      <Flex gap={8} align="center">
        <Text strong style={{ fontSize: 20, lineHeight: 1.4 }}>
          <Private>{`$${data.price}
        `}</Private>
        </Text>
        <Text type="secondary">{data?.period || t("per month")}</Text>
      </Flex>

      <Divider style={{ margin: 0 }} />
      <Flex vertical={true} gap={12}>
        {data?.["list_of_characteristics"].map((el) => (
          <Space key={el}>
            <Icon type={"check_simple"} />
            <Text>{el}</Text>
          </Space>
        ))}
      </Flex>

      <Button
        size="large"
        danger={data.is_active}
        disabled={data.isDisabled}
        onClick={() => onClick(data)}
        className="flex center"
        style={{ marginTop: "auto" }}
      >
        {t(btnText)}
      </Button>
    </Flex>
  )
}

export default PremiumCard
